// File: /js/shared/handlers/handleAjaxSubmit.js

import { buildContext } from '/js/shared/context/requestContext.js';
import { ajaxAction }   from '/js/shared/ajax/ajaxAction.js';
import { normalizeEditorHtml } from '/js/shared/utils/richtextUtils.js';

export function handleAjaxSubmit(event) {
  const form = event.target;

  if (!(form instanceof HTMLFormElement) || form.dataset.ajaxSubmit !== 'true') return;
  event.preventDefault();

  // 1) Copy .richtext → hidden <input>
  form.querySelectorAll('.richtext').forEach(editor => {
    const name = editor.dataset.name;
    if (!name) return;
    const input = form.querySelector(`input[type="hidden"][name="${name}"]`);
    // Same canonical shape the input-time sync writes (audit I8) — the
    // raw innerHTML copy could re-introduce styling the PHP floor then strips.
    if (input) input.value = normalizeEditorHtml(editor.innerHTML);
  });

  const formData = new FormData(form);

  // Pass `form` so scope-hash override applies if the form is embedded
  // inside `[data-scope-hash]` (not a current use case but keeps the
  // override layer uniform across every AJAX-dispatching handler).
  const context = buildContext(form);

  // IMPORTANT:
  // If the form already carries a "hash" (e.g. quiz hash),
  // do not overwrite it with the page context hash (e.g. module hash).
  for (const [key, value] of Object.entries(context)) {
    if (key === 'hash' && formData.has('hash')) continue;
    formData.append(key, value);
  }

  for (const [key, value] of Object.entries(form.dataset)) {
    formData.append(key, value);
  }

  ajaxAction(formData, false);
}